var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHyperlink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-fill",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.232 8.341a1 1 0 0 0-1.307.54.966.966 0 0 1-.219.326A.985.985 0 0 1 8 9.5H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h4c.266 0 .521.105.708.294a.972.972 0 0 1 .217.324 1 1 0 1 0 1.847-.767A3 3 0 0 0 8 .5H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h4a3.007 3.007 0 0 0 2.772-1.85 1 1 0 0 0-.54-1.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6a1 1 0 0 0 1 1h11a1 1 0 0 0 0-2H7a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 .5h-4a3.006 3.006 0 0 0-2.772 1.85 1 1 0 1 0 1.847.767.976.976 0 0 1 .219-.326A.989.989 0 0 1 16 2.5h4a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-4a.987.987 0 0 1-.708-.294.962.962 0 0 1-.217-.324 1 1 0 0 0-1.847.768A3 3 0 0 0 16 11.5h4a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHyperlink);
export default __webpack_public_path__ + "static/media/icon-hyperlink.1adba37b7a1c60bc5c4bd0e401254495.svg";
export { ForwardRef as ReactComponent };